import styled from "styled-components";

export const StyledBackground = styled.div`
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0; 
    width: 100%;
    height: 100%;
`;